// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FLhG","badges":"styles_badges__1n_AI"};